import styled from 'styled-components';
import { colors } from '@alixpartners/ui-components';
import { ApInput } from '@alixpartners/ui-components';
import { colorError } from 'styles/colors';

export const Wrapper = styled.div`
	padding-top: 6px;
`;

export const Title = styled.div`
	font-size: 16px;
	font-style: normal;
	font-weight: 500;
	line-height: 24px;
	letter-spacing: 0.3px;
	text-align: left;
	color: ${colors.grey7};
`;

export const Description = styled.div`
	font-size: 13px;
	font-style: normal;
	font-weight: 400;
	line-height: 32px;
	letter-spacing: 0.8px;
	text-align: left;
	color: ${colors.grey5};
`;

export const PercentageInput = styled(ApInput)`
	input {
		padding-right: 38px;
	}

	div > div {
		width: auto;
		padding-right: 8px;
	}
`;
export const TailSpendValueInput = styled(ApInput)`
	input {
		padding-right: 60px;
	}

	div > div {
		width: auto;
		padding-right: 8px;
	}
`;
export const TailSpendVendorsInput = styled(ApInput)`
	input {
		padding-right: 94px;
	}

	div > div {
		width: auto;
		padding-right: 8px;
	}
`;

export const InputWrapper = styled.div`
	position: relative;
	flex-grow: 1;

	input {
		width: 198px;
		text-overflow: unset;
	}
`;

export const RadioWrapper = styled.div`
	display: flex;
	justify-content: space-between;
	margin-bottom: 19px;
	margin-top: 6px;
`;

export const ErrorLabel = styled.div`
	color: ${colorError};
	margin-top: 5px;
`;

export const Line = styled.div`
	border-top: 1px solid ${colors.grey3};
	width: 100%;
	margin: 30px 0 24px 0;
`;
